import React from 'react';
import { DarkCard } from './RankedCard';
import { fmtMinutes } from './usageApi';

const Stat = ({ label, value, hint, testId }) => (
  <div className="rounded-lg bg-white/[0.03] p-3" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-wider text-neutral-500">{label}</div>
    <div className="mt-1 text-xl font-semibold text-white tabular-nums">{value}</div>
    <div className="text-[11px] text-neutral-500">{hint}</div>
  </div>
);

export const StickinessCard = ({ kpis }) => (
  <DarkCard title="Engagement" hint="Relative to end date" testId="usage-stickiness">
    <div className="grid grid-cols-3 gap-2">
      <Stat label="DAU" value={kpis.dau} hint="Today" testId="usage-kpi-dau" />
      <Stat label="WAU" value={kpis.wau} hint="Last 7 days" testId="usage-kpi-wau" />
      <Stat label="MAU" value={kpis.mau} hint="Last 30 days" testId="usage-kpi-mau" />
    </div>
    <div className="mt-4">
      <div className="mb-1.5 flex justify-between text-xs">
        <span className="text-neutral-300">Stickiness (DAU / MAU)</span>
        <span className="tabular-nums text-neutral-400" data-testid="usage-kpi-stickiness">{kpis.stickiness}%</span>
      </div>
      <div className="h-1 rounded-full bg-white/10">
        <div className="h-1 rounded-full bg-[#7ee8e2]" style={{ width: `${kpis.stickiness}%` }} />
      </div>
    </div>
    <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
      <div className="flex justify-between rounded-lg bg-white/[0.03] px-3 py-2" data-testid="usage-kpi-logins">
        <span className="text-neutral-500">Logins</span><span className="tabular-nums text-neutral-200">{kpis.logins}</span>
      </div>
      <div className="flex justify-between rounded-lg bg-white/[0.03] px-3 py-2" data-testid="usage-kpi-avg_session">
        <span className="text-neutral-500">Avg session</span><span className="tabular-nums text-neutral-200">{fmtMinutes(kpis.avg_session_minutes)}</span>
      </div>
    </div>
  </DarkCard>
);
